<template>
  <div class="home">
    <OrderDetailPage />
  </div>
</template>

<script>
import OrderDetailPage from '../components/elements/pages/OrderDetailPage.vue'
export default {
  name: 'OrderDetails',
  metaInfo: {
    title: 'Order Details'
  },
  components: {
    OrderDetailPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
